module.exports = __webpack_public_path__ + "static/Sports-9002ee536240a5ba3c1d399edad478f7.png";